import {useQueries} from "@tanstack/react-query";
import natureService from "../../../../../../services/web/nature-service.js";
import organizationService from "../../../../../../services/web/organization-service.js";
import ecapTemplateService from "../../../../../../services/web/ecap-template-service.js";
import groupService from "../../../../../../services/web/group-service.js";

const UseFetchData = () => {
    const queries = useQueries({
        queries: [
            {
                queryKey: ['reasons'],
                queryFn: () => natureService.getAllToSelect()
            },
            {
                queryKey: ['organizations'],
                queryFn: () => organizationService.list().then(data => data.map(({id, name}) => ({value: id, label: name})))
            },
            {
                queryKey: ['templates'],
                queryFn: () => ecapTemplateService.options()
            },
            {
                queryKey: ['occurrenceGroup'],
                queryFn: () => groupService.getOptionsMyUser("occurrence")
            },
        ]
    });

    return {
        reasons: queries[0].data ?? [],
        organizations: queries[1].data ?? [],
        templates: queries[2].data ?? [],
        occurrenceGroup: queries[3],
    }
};

export default UseFetchData;